import { render } from "./ViewMaterial.vue?vue&type=template&id=5e58511e&scoped=true"
import script from "./ViewMaterial.vue?vue&type=script&lang=js"
export * from "./ViewMaterial.vue?vue&type=script&lang=js"

import "./ViewMaterial.vue?vue&type=style&index=0&id=5e58511e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e58511e"]])

export default __exports__